<template>
    <b-container fluid class="animated fadeIn">
        <h1>Protesto - Exibir Exceções</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i
                                    class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna :fields="fields" :showColunms="showColunms"
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-button class="mx-1 " variant="primary" @click.prevent="encaminharDisponivel"
                            :disabled="!selecteds.length"><i class="fa fa-pencil-square-o"></i> Retornar CDA</b-button>
                        <b-button class="mx-1 " variant="primary" @click.prevent="retornarInativarCda"
                            :disabled="!selecteds.length"><i class="fa fa-pencil-square-o"></i> Retornar CDA e Inativar Cad.
                            Exceção</b-button>
                        <b-button class="mx-1 " variant="primary" @click.prevent="atualizarStatus"
                            :disabled="!selecteds.length"><i class="fa fa-refresh"></i> Atualizar Status</b-button>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect v-model="filtrarPor" :show-labels="false" :options="opcoesFiltro"
                                                :multiple="true" :close-on-select="false" :clear-on-select="false"
                                                :preserve-search="true" placeholder="Selecione" track-by="id"
                                                label="filtro">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
                                            <b-form-input v-model="filtro.numeroDivida" type="number" id="numeroDivida"
                                                maxlength="8" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                            <the-mask id="cpfCnpj" class="form-control" v-model="filtro.cpfCnpj"
                                                :mask="['XX.XXX.XXX/XXXX-##', 'XXX.XXX.XXX-XX']" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="CADICMS:" label-for="cadicms" class="text-label">
                                            <b-form-input v-model="filtro.cadimcs" type="text" id="cadicms"
                                                maxlength="20" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Comarca:" label-for="comarca" class="text-label">
                                            <multiselect v-model="filtro.comarca" :show-labels="false"
                                                :options="dados.comarcas" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="codComarca">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Contribuinte:" label-for="contribuinte" class="text-label">
                                            <b-form-input v-model="filtro.contribuinte" type="text" id="contribuinte"
                                                maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                                            <multiselect v-model="filtro.credito" :show-labels="false"
                                                :options="dados.creditos" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="id">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Início):" label-for="dtInscricaoInicio"
                                            class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtInscricaoInicio"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Fim)" label-for="dtInscricaoFim"
                                            class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtInscricaoFim"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 8).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Motivo:" label-for="motivo" class="text-label">
                                            <b-form-input v-model="filtro.motivo" type="text" id="motivo" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button variant="primary" class="fonte-branca" @click="filtrar">
                                                <i class="fa fa-search"></i> Pesquisar
                                            </b-button>
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                    <b-row class="d-flex justify-content-between mt-2">
                        <b-col align-self="end">
                            <div class="d-flex justify-content-between mb-3" style="float:right">
                                <div>
                                    <!-- <b-button class="mx-1 " variant="primary" @click.prevent="encaminharDisponivel" :disabled="!selecteds.length"><i class="fa fa-pencil-square-o"></i> Retornar CDA</b-button> -->
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas Disponibilizadas - Valor Total: <strong>R$ {{
                                                configTable.totalGeral | currency }}</strong> &nbsp; Quantidade:
                                                <strong>{{ configTable.quantidadeGeral }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabelaExcecoesProtesto :resultado="resultado" :fields="fields"
                                        :configTable="configTable" :selecteds="selecteds" @sortingChanged="consultarDividas"
                                        @consultarDividas="consultarDividas" />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col align-self="end">
                                            <label style="float:right">Quantidade selecionada: {{ selecteds.length }} &nbsp;
                                                Valor Total: <strong>R$ {{ totalSelectedValue | currency }}</strong></label>
                                        </b-col>
                                    </b-row>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <div class="d-flex justify-content-between mb-3">
                            <div>
                                <b-button class="mx-1 " variant="primary" :disabled="loadCSV" @click.prevent="exportCSV"><i
                                        class="fa fa-cloud-download" v-if="!loadCSV"></i>
                                    <b-spinner small v-if="loadCSV"></b-spinner>
                                    Exportar CSV
                                </b-button>
                                <b-button class="mx-1" variant="secondary" @click="voltar"><i class="fa fa-reply"></i>
                                    Voltar</b-button>
                            </div>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompExibirOcultarColuna from './components/CompBotaoExibirOcultarColuna'
import CompPaginacao from './components/CompPaginacao'
import CompTabelaExcecoesProtesto from './components/CompTabelaExcecoesProtesto'

export default {
    name: 'ExibirExcecoesProtesto',
    components: {
        CompExibirOcultarColuna,
        CompPaginacao,
        CompTabelaExcecoesProtesto
    },
    data() {
        return {
            ano: null,
            mes: null,
            filtrarPor: [],
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Número da Dívida'
                },
                {
                    id: 2,
                    filtro: 'CPF/CNPJ'
                },
                {
                    id: 3,
                    filtro: 'CAD ICMS'
                },
                {
                    id: 4,
                    filtro: 'Comarca'
                },
                {
                    id: 5,
                    filtro: 'Contribuinte'
                },
                {
                    id: 6,
                    filtro: 'Tipo de Crédito'
                },
                {
                    id: 7,
                    filtro: 'Data Inscrição'
                },
                {
                    id: 8,
                    filtro: 'Motivo'
                }
            ],
            filtro: {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                motivo: null,
            },
            dados: {
                comarcas: [],
                creditos: []
            },
            configTable: {
                perPage: 100,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
                totalGeral: 0.00,
                quantidadeGeral: 0
            },
            showColunms: [],
            selecteds: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            loadCSV: false,
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultarDividas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
        totalSelectedValue() {
            let total = 0.00
            this.selecteds.forEach(divida => {
                total = total + divida.valor
            })
            return total
        },
        totalResultValue() {
            let total = 0.00
            this.resultado.forEach(result => {
                result.dividas.forEach(divida => {
                    total = total + divida.valor
                })
            })
            return total
        },
    },
    methods: {
        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                motivo: null,
            }
            this.filtrarPor = []
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.configTable.rows = 0
            this.resultado = []
            this.selecteds = []
            this.consultarDividas()
        },

        /**
         * Enviar CDA's para protesto
         */
        encaminharDisponivel() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            let selecionadas = []
            this.selecteds.forEach(cda => {
                selecionadas.push({
                    codCdaSefa: cda.codCdaSefa
                })
            })

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaExcecaoProtesto/encaminharDisponiveis`, selecionadas, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Dívidas encaminhadas para disponível!'] });
                    this.selecteds = []
                })
                .finally(() => {
                    this.configTable.currentPage = 1
                    this.loadingExit()
                    this.consultarDividas()
                })
        },

        /**
 * Retornar CDA's e inativar cadastro de exceções
 */
        retornarInativarCda() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            let selecionadas = []
            this.selecteds.forEach(cda => {
                selecionadas.push({
                    codCdaSefa: cda.codCdaSefa
                })
            })

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaExcecaoProtesto/retornarInativarCda`, selecionadas, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['CDAs Retornadas e Cadastro de Exceções Inativado.'] });
                    this.selecteds = []
                })
                .finally(() => {
                    this.configTable.currentPage = 1
                    this.loadingExit()
                    this.consultarDividas()
                })
        },

        /**
        * Atualizar Status FIR e salvar momento de atualização
        */
        atualizarStatus() {
            const urlApi = process.env.VUE_APP_ROOT_API
            let codigos = [];
            this.selecteds.forEach(cda => {
                codigos.push(cda.codCdaSefa);
            });

            this.loadingEnter()
            axios.post(`${urlApi}/v1/consultarCdas/atualizarValor`, codigos, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            }).then(() => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Status Atualizados com Sucesso.'] });
                this.selecteds = []
            }).finally(() => {
                this.configTable.currentPage = 1
                this.loadingExit()
                this.consultarDividas()
            })
        },

        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo: ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API
            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if (i == 0 || i == 2 || i == 3 || i == 4 || i == 6 || i == 7)
                return 'text-center justify-content-center'
            if (i == 5)
                return 'text-right justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Exporta as CDA's em CVS
         */
        async exportCSV() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadCSV = true
            if (this.selecteds.length) {
                let selecionadas = []
                this.selecteds.forEach(cda => {
                    selecionadas.push({
                        codCdaSefa: cda.codCdaSefa
                    })
                })

                axios.post(`${urlApi}/v1/cdaExcecaoProtesto/exportarCsv`, selecionadas, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                    .then(response => {
                        this.downloadCSV(response)
                    }).finally(() => {
                        this.loadCSV = false
                    })
            } else {
                const filtro = this.obterFiltro()

                axios.post(`${urlApi}/v1/cdaExcecaoProtesto/exportarCsv/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                    .then(response => {
                        this.downloadCSV(response)
                    }).finally(() => {
                        this.loadCSV = false
                    })
            }
        },

        /**
         * Realizar o download do arquivo CSV recebido do response
         */
        downloadCSV(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CDAExcecaoProtesto.csv');
            document.body.appendChild(link);
            link.click();
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },

        /**
         * Consultar divídas
         */
        async consultarDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if (this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaExcecaoProtesto/consultar/${this.ano}/${this.mes}?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
                .then(response => {
                    this.resultado = response.data.resultado
                    this.configTable.quantidadeGeral = response.data.rows
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows
                    }

                    this.resultado.forEach(result => {
                        result.checked = false
                        this.selecteds.forEach(selected => {
                            if (result.codCdaSefa == selected.codCdaSefa) {
                                result.checked = true
                            }
                        })
                    })

                }).finally(() => {
                    this.loadingExit()
                })

            this.consultarTotalDividas()
        },

        /**
         * Obter filtro
         */
        obterFiltro() {
            return {
                numeroDivida: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.numeroDivida : null,
                cpfCnpj: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.cpfCnpj : null,
                cadicms: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.cadimcs : null,
                comarcas: (this.filtrarPor.filter(e => e.id == 4).length > 0) ? this.filtro.comarca : null,
                contribuinte: (this.filtrarPor.filter(e => e.id == 5).length > 0) ? this.filtro.contribuinte : null,
                tipoCredito: (this.filtrarPor.filter(e => e.id == 6).length > 0) ? this.filtro.credito : null,
                dtInscricaoInicio: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? (this.filtro.dtInscricaoInicio ? this.filtro.dtInscricaoInicio.toString() : null) : null,
                dtInscricaoFim: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? (this.filtro.dtInscricaoFim ? this.filtro.dtInscricaoFim.toString() : null) : null,
                motivo: (this.filtrarPor.filter(e => e.id == 8).length > 0) ? this.filtro.motivo : null,
            }
        },

        async consultarTotalDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            axios.post(`${urlApi}/v1/cdaExcecaoProtesto/consultar/valorTotal/${this.ano}/${this.mes}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
                .then(response => {
                    this.configTable.totalGeral = response.data
                })
        },

        /**
         * Listar comarcas
         */
        async listarComarcas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/comarca/listar/protesto`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                .then(response => {
                    this.dados.comarcas = response.data
                })
        },

        /**
         * Listar os Tipos de Origem
         */
        async listarTipoOrigem() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaExcecaoProtesto/listarOrigem`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                .then(response => {
                    this.dados.origens = response.data
                })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaExcecaoProtesto/listarTipoCredito`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                .then(response => {
                    this.dados.creditos = response.data
                })
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'CDAsExcecoesProtesto'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            sortable: true,
                            sortDirection: "desc",
                            class: this.checkClassTable(i),
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        }

    },
    mounted() {
        const dataAtual = new Date(this.$store.getters.getDataMonitoramento)

        this.ano = dataAtual.getFullYear()
        this.mes = dataAtual.getMonth() + 1

        this.$store.commit("setMessages", {});

        this.obterConfiguracaoUsuario()
        this.listarComarcas()
        this.listarTipoOrigem()
        this.listarTipoCredito()

        this.consultarDividas()

    }
}
</script>

<style></style>
